import React from "react";
import HomeNav from "./HomeNav";


const Shimmer = () => {
  // const shimmerCards = Array(15).fill(null)
  return (
    <>
      <HomeNav position="relative" />
    
      <section className="blog-section mt-5">
        <div className="container-fluid">
          <div className="row ">
            <div className="col-lg-9 col-md-8">
              <div className="row">
                  {
                    Array.from({length: 4}).map((_, index)=>(
                      <div className="col-lg-6 col-md-6"  key={index}>
                      <div className="card-shimmer">
                      <div className="shimmerBG media"></div>
                      <div className="p-32">
                        <div className="shimmerBG title-line"></div>
                        <div className="shimmerBG title-line end"></div>
  
                        <div className="shimmerBG content-line m-t-24"></div>
                        <div className="shimmerBG content-line"></div>
                        <div className="shimmerBG content-line"></div>
                        <div className="shimmerBG content-line"></div>
                        <div className="shimmerBG content-line end"></div>
                      </div>
                    </div>
                  </div>
                    ))
                  }
               
                </div>
            </div>
          
          </div>
        </div>
      </section>
    </>
  );
};

export default Shimmer;
